// 动画特效 store — 独立于 gameStore，避免引擎重渲染
import { create } from "zustand";

export interface FxEntry {
  class: string; // CSS class，如 "fx--damage"
  key: number; // React key，强制 remount 重放动画
  dmg?: number; // 飘字数值（伤害/治疗）
}

export interface JudgmentFx {
  key: number; // React key，强制 remount 重放动画
  playerName: string;
  cardName: string;
  suit: string; // 判定牌花色
  armorName: string;
  success: boolean;
  responseKind?: string;
}

interface FxStore {
  map: Record<string, FxEntry>; // playerId → FxEntry
  history: FxEntry[]; // 调试用：最近触发的 fx 记录（最多 50 条）
  judgment: JudgmentFx | null;
  setFx: (playerId: string, entry: FxEntry) => void;
  clearFx: (playerId: string) => void;
  setJudgment: (fx: JudgmentFx) => void;
  clearJudgment: () => void;
}

let fxKey = 0;
export const nextFxKey = () => ++fxKey;

export const useFxStore = create<FxStore>((set) => ({
  map: {},
  history: [],
  judgment: null,
  setFx: (playerId, entry) =>
    set((s) => ({
      map: { ...s.map, [playerId]: entry },
      history: [{ ...entry, playerId } as FxEntry & { playerId: string }, ...s.history].slice(0, 50),
    })),
  clearFx: (playerId) =>
    set((s) => {
      if (!s.map[playerId]) return s;
      const next = { ...s.map };
      delete next[playerId];
      return { map: next };
    }),
  setJudgment: (fx) => set({ judgment: fx }),
  clearJudgment: () => set({ judgment: null }),
}));

// 调试：浏览器环境暴露 store 到 window
if (typeof window !== "undefined") {
  (window as unknown as { __fxStore?: unknown }).__fxStore = useFxStore;
}
